<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Nem számlázott szállítólevelek</span>
      <el-button
        style="float: right; margin-top: -6px;"
        size="small"
        @click="$router.push('/sales/customer-sales')"
      >
        Szállítólevelek megyitása
        <i class="el-icon-d-arrow-right"></i>
      </el-button>
    </div>
    <partner-list
      @createInvoice="onCreateInvoice"
    />
    <div
      v-if="!loading && customers.data && customers.data.length === 0"
      style="text-align: center;"
    >
      <el-alert
        title="Az összes szállítólevél kiszámlázva"
        type="success"
        show-icon
        center
        :closable="false"
      />
    </div>
<!--    <invoice-dialog-->
<!--      v-if="showDialog"-->
<!--      :partner-id="partnerId"-->
<!--      :sale-ids="saleIds"-->
<!--      :representative-sale-ids="representativeSaleIds"-->
<!--      :fallback-url="'/'"-->
<!--      type="add"-->
<!--      @close="showDialog = false"-->
<!--    />-->
  </el-card>
</template>

<script>
  import InvoiceDialog from '../../sales/invoices/Dialog';
  import PartnerList from './PartnerList';

  export default {
    components: { InvoiceDialog, PartnerList },
    data() {
      return {
        showDialog: false,
        partnerId: 0,
        saleIds: [],
        representativeSaleIds: [],
      };
    },

    computed: {
      loading() {
        return this.$store.getters['partner/customersWithBillableLoading'];
      },
      customers() {
        return this.$store.getters['partner/customersWithBillable'];
      }
    },

    methods: {
      onCreateInvoice(data) {
        console.log(data)
        this.partnerId = data.customerId;
        this.saleIds = data.selectedSaleIds;
        this.representativeSaleIds = data.selectedRepresentativeSaleIds;
        this.showDialog = true;

        this.$router.push({
          path: '/sales/invoices/add',
          query: {
            partnerId: this.partnerId,
            saleIds: this.saleIds,
            representativeSaleIds: this.representativeSaleIds,
          }
        })
      }
    }
  };
</script>
